import * as React from 'react';
import BasicSelect from './BasicSelect.jsx';
import Label from './Label.jsx';
import ResponsiveDateRangePicker from './ResponsiveDateRangePicker.jsx';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import GcDateRangePicker from './GcDateRangePicker.jsx';

export default function SelectDate(props) {
  const { 
    slug, 
    label, 
    items1, 
    items2, 
    selectedItems1, 
    selectedItems2, 
    autoTrad, 
    parentFunction, 
    custom = false,
    periodChoice = false,
    selectedDates,
    disabled = false
  } = props;

  return (
    <ThemeProvider theme={backYouTheme}>
      <Label htmlForValue={"select-date-1"} label={label}/>
      <div className="row">
        <div className={periodChoice ? 'col-6' : 'col-12'}>
          <BasicSelect slug="date1" items={items1} selectedItems={selectedItems1} autoTrad={autoTrad} parentFunction={parentFunction} displayEmptyValue={periodChoice} disabled={disabled} />
        </div>
        {periodChoice && (
          <div className="col-6">
            <BasicSelect slug="date2" items={items2} selectedItems={selectedItems2} autoTrad={autoTrad} parentFunction={parentFunction} disabled={disabled} />
          </div>
        )}

        {
          custom &&
          <div className="col-12 mt-2">
            {/* <ResponsiveDateRangePicker parentFunction={parentFunction} selectedDates={selectedDates} /> */}

            <GcDateRangePicker
              slug="daterange"
              parentFunction={parentFunction} 
              selectedDates={selectedDates}
            />
          </div>
        }

        {(!custom && !periodChoice) && (
          <div className="col-12 mt-2">
            <GcDateRangePicker
              slug="daterange"
              parentFunction={parentFunction} 
              selectedDates={selectedDates}
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}